const SYSTEM_FILES = new Set([
  'soul.md',
  'user.md',
  'agents.md',
  'tools.md',
  'memory.md',
  'identity.md',
  'workspace.md',
]);

/**
 * Returns true if the path refers to a copilot system file that should not
 * be surfaced as a downloadable link. Normalizes case, strips leading `./`,
 * and resolves `..` segments to prevent trivial bypasses.
 */
export function isSystemPath(path: string): boolean {
  const normalized = path
    .replace(/^\.\//, '')
    .toLowerCase()
    .split('/')
    .reduce<string[]>((segments, segment) => {
      if (segment === '..') {
        segments.pop();
      } else if (segment !== '.' && segment !== '') {
        segments.push(segment);
      }
      return segments;
    }, [])
    .join('/');

  if (SYSTEM_FILES.has(normalized)) return true;
  if (normalized.includes('skills/')) return true;
  if (normalized.includes('memory/')) return true;
  return false;
}
